import HttpService from './HttpService';

export default class MovementService extends HttpService {
    endPoint = "/v1/movements"
}
